import { render, staticRenderFns } from "./private-fl223-winner-selection-proposal-card.vue?vue&type=template&id=cdeb7df4&scoped=true&"
import script from "./private-fl223-winner-selection-proposal-card.vue?vue&type=script&lang=js&"
export * from "./private-fl223-winner-selection-proposal-card.vue?vue&type=script&lang=js&"
import style0 from "./private-fl223-winner-selection-proposal-card.vue?vue&type=style&index=0&id=cdeb7df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdeb7df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdeb7df4')) {
      api.createRecord('cdeb7df4', component.options)
    } else {
      api.reload('cdeb7df4', component.options)
    }
    module.hot.accept("./private-fl223-winner-selection-proposal-card.vue?vue&type=template&id=cdeb7df4&scoped=true&", function () {
      api.rerender('cdeb7df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl223/partials/private-fl223-winner-selection-proposal-card.vue"
export default component.exports